import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import '../servicesOperation.css'
import InputAutocomplete from '../InputAutocomplete_Form';
import Checkbox from '@mui/material/Checkbox';
import MuiAlert from '@mui/material/Alert';
import Grid from '@mui/material/Unstable_Grid2';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { options_origen_devolucion, options_deposito_destino, options_condicion, options_sintoma, options_aceptamos_devolucion_safe, data_aceptamos_devolucion } from '../Helper/data_Admin';
import { TextField } from '@mui/material';


const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

// Definimos el componente Admin
const Taller_Form_Body_Procesado = ({formData,setFormData,isLoading,isSubmitting, isSubmitSuccessful, datataller_componente, datataller_deposito_destino, datataller_descripcion, datataller_estado_sku, datataller_estetica_packaging, datataller_estetica_producto, datataller_falla, datataller_lote, datataller_motivo_del_scrap, datataller_reparacion, datataller_responsable,}) => {
        
    //Estado para capturar el valor del checkbox
    /* const [checkBox, setCheckBox] = useState(false); 
    
    //Estados para validación de cada input
    const [touched, setTouched] = useState({});
    const [errors, setErrors] = useState({}); */
    
    // Función para marcar un campo como tocado
    /* const handleBlur = (id) => {
        setTouched((prevState) => ({
            ...prevState,
            [id]: true,
        }));
        validateField(id, formData[id]);
    };

    
    const validateField = (id, value) => {
        // Si el valor es nulo o el string vacío, establecer el error
        if (!value) {
            setErrors((prevState) => ({
                ...prevState,
                [id]: "Este campo es obligatorio",
            }));
        } else {
            // Eliminar el error si el campo es válido
            setErrors(prevState => {
                const newState = { ...prevState };
                delete newState[id];
                return newState;
            });
        }
    }; */

    
    //Captura Inputs Autocomplete
    /* const handleChangeAutoComplete = (id, newInputValue) => {
      
        //console.log("Nuevo valor seleccionado:", newInputValue);
        
        setFormData((prevState) => ({
            ...prevState,
            [id]: newInputValue ? newInputValue.id : null  //AL VOLVER DE INGLÉS, VER ESTO DE CAMBIAR QUE SE GUARDE EL ID, Y NO EL NOMBRE DEL VALOR.
        }));

        if(id === 'id_numero_serie' || id === 'id_codigo_barra'){
            setFormData((prevState) => ({
                ...prevState,
                [id]: newInputValue ? newInputValue : null  //AL VOLVER DE INGLÉS, VER ESTO DE CAMBIAR QUE SE GUARDE EL ID, Y NO EL NOMBRE DEL VALOR.
            }));
            
        }
        //setTouched({ ...touched, [id]: true }); // Marca el campo como tocado
        setTouched(prevState => ({ ...prevState, [id]: true }));
        // Validar después de actualizar
        validateField(id, newInputValue);

    } */

    //Función para habilitar o bloquear botón de Enviar una vez que haya datos en cada Input
    /* const isFormValid = () => {
        // Asumiendo que formData es un objeto que contiene todos los campos del formulario como propiedades
        const requiredFields = [ 'id_descripcion', 'id_lote', 'id_falla','id_componente', 'id_estetica_packaging', 'id_estetica_producto', 'id_deposito_destino', 'id_reparacion', 'id_estado_sku', 'id_responsable'];
    
        // Verifica si alguno de los campos requeridos está vacío
        return requiredFields.every(field => {
            const value = formData[field];
            if (typeof value === 'string') {
                return value.trim() !== '';
            } else {
                return value !== null && value !== undefined; // Asume que para los números y booleanos, solo verificar si no son nulos o indefinidos
            }
        });
    }; */
    

/*     const descripcion_Seleccionado = datataller_descripcion.find( (option) => option.id === formData['id_descripcion']);
    const lote_Seleccionado = datataller_lote.find( (option) => option.id === formData['id_lote']);
    const falla_Seleccionado = datataller_falla.find( (option) => option.id === formData['id_falla']);
    const componente_Seleccionado = datataller_componente.find( (option) => option.id === formData['id_componente']);
    const estetica_packaging_Seleccionado = datataller_estetica_packaging.find( (option) => option.id === formData['id_estetica_packaging']);
    const estetica_producto_Seleccionado = datataller_estetica_producto.find( (option) => option.id === formData['id_estetica_producto']);

    const numero_serie_Seleccionado = formData['id_numero_serie']

    const deposito_destino_Seleccionado = datataller_deposito_destino.find( (option) => option.id === formData['id_deposito_destino']);
    const reparacion_Seleccionado = datataller_reparacion.find( (option) => option.id === formData['id_reparacion']);
    const motivo_del_scrap_Seleccionado = datataller_motivo_del_scrap.find( (option) => option.id === formData['id_motivo_scrap']);

    const codgio_barra_Seleccionado = formData['id_codigo_barra']
    
    const estado_sku_Seleccionado = datataller_estado_sku.find( (option) => option.id === formData['id_estado_sku']);
    const responsable_Seleccionado = datataller_responsable.find( (option) => option.id === formData['id_responsable']);
 */

    return (
        <>
                {isLoading ? ( <></> ) : (

                    <>
                                <Box sx={{ flexGrow: 1 }}>
                                    <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                                        <Grid item  xs={12} sm={4} md={4}  key='1'>
                                                <TextField sx={{width: '100%'}} id='id_descripcion' label="Descripción" value={formData.descripcion_name} disabled />
                                        </Grid>
                                        <Grid item  xs={12} sm={4} md={4}  key='2'>
                                                <TextField sx={{width: '100%'}} id='id_lote' label="Lote" value={formData.lote_name} disabled />
                                        </Grid>
                                        <Grid item  xs={12} sm={4} md={4}  key='3'>
                                                <TextField sx={{width: '100%'}} id='id_falla' label="Falla" value={formData.falla_name} disabled />
                                        </Grid>
                                        <Grid item  xs={12} sm={4} md={4}  key='4'>
                                                <TextField sx={{width: '100%'}} id='id_componente' label="Componente" value={formData.componente_name} disabled />
                                        </Grid>
                                        <Grid item  xs={12} sm={4} md={4}  key='5'>
                                                <TextField sx={{width: '100%'}} id='id_estetica_packaging' label="Estetica Packaging" value={formData.estetica_packaging_name} disabled />
                                        </Grid>
                                        <Grid item  xs={12} sm={4} md={4}  key='6'>
                                                <TextField sx={{width: '100%'}} id='id_estetica_producto' label="Estetica Producto" value={formData.estetica_producto_name} disabled />
                                        </Grid>
                                        <Grid item  xs={12} sm={4} md={4}  key='7'>
                                                <TextField sx={{width: '100%'}} id='id_numero_serie' label="Número de Serie" value={formData.numero_serie_name} disabled />
                                        </Grid>
                                        <Grid item  xs={12} sm={4} md={4}  key='8'>
                                                <TextField sx={{width: '100%'}} id='id_deposito_destino' label="Destino Devolucion" value={formData.deposito_destino_name} disabled />
                                        </Grid>
                                        <Grid item  xs={12} sm={4} md={4}  key='9'>
                                                <TextField sx={{width: '100%'}} id='id_reparacion' label="Reparación" value={formData.reparacion_name} disabled />
                                        </Grid>
                                        <Grid item  xs={12} sm={4} md={4}  key='10'>
                                                <TextField sx={{width: '100%'}} id='id_motivo_scrap' label="Motivo" value={formData.motivo_del_scrap_name} disabled />
                                        </Grid>
                                        <Grid item  xs={12} sm={4} md={4}  key='11'>
                                                <TextField sx={{width: '100%'}} id='id_codigo_barra' label="Código de Barra" value={formData.codigo_barra_name} disabled />
                                        </Grid>
                                        <Grid item  xs={12} sm={4} md={4}  key='12'>
                                                <TextField sx={{width: '100%'}} id='id_estado_sku' label="Estado" value={formData.estado_sku_name} disabled />
                                        </Grid>
                                        <Grid item  xs={12} sm={4} md={4}  key='13'>
                                                <TextField sx={{width: '100%'}} id='id_responsable' label="Responsable" value={formData.responsable_name} disabled />
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4} key='14'>
                                            <TextField sx={{width: '100%'}} id="id_comentarios" label="Comentarios" value={formData.id_comentarios} disabled/>
                                        </Grid>
                                    </Grid>                
                                </Box>
                                
                                <div className='send_btn_container_admin'>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        sx={{marginTop: '40px'}}
                                        disabled
                                    >
                                        Enviar
                                    </Button>

                                </div>
                    </>
                )}
        </>
    );
};

export default Taller_Form_Body_Procesado;